import { JobSearchResultResponse } from '@doda/api-client/aspida/@types';
import { createDefaultLinkForJobDetail } from 'components/JobCard/logics/createDefaultLinkForJobDetail';
import { JOB_CARD_ACTION } from '../../constants';

/**
 * createJobDetailUrlのProps
 * @param job 求人一覧
 * @param pageCount ページ番号
 * @param soCount 検索結果数
 * @param tp 求人種別
 * @param index 表示順
 * @param isLogin ログイン状態
 */
export interface ArgumentType {
  job: JobSearchResultResponse;
  pageCount: number;
  soCount: number;
  tp: string | undefined;
  index: number;
  isLogin;
}

/**
 * 求人カード押下時の遷移先URL生成処理
 * @param param.job 求人一覧
 * @param param.tp 求人種別
 * @param param.index 表示順
 * @param param.pageCount ページ番号
 * @param param.soCount 検索結果数
 * @param param.isLogin ログイン状態
 * @returns 求人カード押下時の遷移先URL
 */
export const createJobDetailUrl = ({
  job,
  tp,
  index,
  pageCount,
  soCount,
  isLogin,
}: ArgumentType) => {
  const { jid, isRead, jobManuscriptType } = job;
  const destinationURL = createDefaultLinkForJobDetail(
    jid ?? '',
    isRead ?? false,
    tp
  );

  const posCount = index + 1 + (pageCount - 1) * soCount;
  const usrclk_searchListCassette = `usrclk_searchListCassette=PC-${isLogin ? 'login' : 'logout'}JobSearchList_kyujinSearchResultCassetteArea_pos-${posCount}_size-${jobManuscriptType}_`;
  const titleLink = `${destinationURL}&${usrclk_searchListCassette}${JOB_CARD_ACTION.COMPANY_NAME_LINK}`;
  const imageLink = `${destinationURL}&${usrclk_searchListCassette}${JOB_CARD_ACTION.IMAGE}`;
  const footerButtonLink = `${destinationURL}&${usrclk_searchListCassette}${JOB_CARD_ACTION.JOB_DETAIL_BUTTON}`;
  const bookmarkUrlQuery = `${usrclk_searchListCassette}${JOB_CARD_ACTION.BOOK_MARK_LIST}`;

  return {
    destinationURL,
    titleLink,
    imageLink,
    footerButtonLink,
    bookmarkUrlQuery,
  };
};
